module.exports = __webpack_public_path__ + "static/media/signage-industrial-img24.dbd2d368.jpg";